import classes from "./integrationStyles.module.scss"
import { useEffect, useState } from 'react';

//https://dev1.e-invoices.online/app/2e62b70d-9878-11ec-90f9-9536f254aa7f?id=b332aec2-95ce-11ee-9108-ee67f6910206
const InvoiceDocsIframe = ({url, onExecuteResponse, ...props})=>{
    const [keyState, setKeystate] = useState(0);

    useEffect(() => {
        setKeystate(keyState+1)
    }, [onExecuteResponse])

    return(<>
    <div className={`${classes["container-nolimit"]}`}>
        {url && <iframe
            key={keyState}
            //src={process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+`/${url}?inline=true` : `/${url}?inline=true`}
            src={url}
            title={`iframe-invoiceIframe`}
            width="100%"
            height="100%"
        ></iframe>}
    </div>
    </>)
}

export default InvoiceDocsIframe;